import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 查询品牌列表
export function queryBlandList(data: any, query: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/bland/queryList.ac`,
    method: 'post',
    params: query,
    data,
  });
}

// 查询季节列表
export function getSeasonList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/season/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询波段列表
export function getRangeList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/ranges/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询商品分类列表
export function getCategoryList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/category/queryList.ac`,
    method: 'post',
    data,
  });
}

// 查询用户列表
export function getStaffList(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/user/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 同步进销存仓库
export function syncFromIs() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/storehouse/syncFromIs.ac`,
    method: 'post',
  });
}

// 查询仓库列表
export function queryStoreHouseList(data: any, params?: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/storehouse/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 查询商品列表
export function getGoodsList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询商品列表汇总
export function getGoodsListSum(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sum.ac`,
    method: 'post',
    data,
  });
}

// 查询单品列表汇总
export function getGoodsListSumForSku(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sumForSku.ac`,
    method: 'post',
    data,
  });
}

// 查询供应商列表
export function querySupplierList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/supplier/querySupplierList.ac`,
    method: 'post',
    data,
  });
}
// 商品详情
export function goodGet(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/get.ac`,
    method: 'post',
    data,
  });
}

// 新增商品
export function goodInsert(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/insert.ac`,
    method: 'post',
    data,
  });
}

// 商品编辑
export function goodUpdate(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/update.ac`,
    method: 'post',
    data,
  });
}

// 查询颜色列表
export function getColorList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/color/queryList.ac`,
    method: 'post',
    data,
  });
}

// 获取默认颜色
export function getColorDefault() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/color/getDefault.ac`,
    method: 'post',
  });
}

// 新增颜色
export function addColor(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/color/insert.ac`,
    method: 'post',
    data,
  });
}

// 获取默认尺码
export function getSizeDefault() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/size/getDefault.ac`,
    method: 'post',
  });
}

// 判断单品条码是否被占用
export function checkoutGoodsSkuBarcode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutGoodsSkuBarcode.ac`,
    method: 'post',
    data,
  });
}

// 判断商品条码是否被占用
export function checkoutGoodsBarcode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutGoodsBarcode.ac`,
    method: 'post',
    data,
  });
}

// 判断商品货号是否被占用
export function checkoutGoodsSn(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutGoodsSn.ac`,
    method: 'post',
    data,
  });
}

// 判断设计款号是否被占用
export function checkoutDesignSn(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutDesignSn.ac`,
    method: 'post',
    data,
  });
}

// 查询物料分类列表
export function getMaterialCategoryList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/material/category/getList.ac`,
    method: 'post',
    data,
  });
}

// 获取物料列表
export function getMaterialList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/material/getMaterialList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询生产节点模板列表
export function queryProductionNodeTemplateList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/workProcessTemplate/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 获取生产节点模板详情
export function getProductionNodeTpDetail(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/workProcessTemplate/get.ac`,
    method: 'post',
    data,
  });
}

// 查询尺码列表
export function getSizeList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/size/queryList.ac`,
    method: 'post',
    data,
  });
}

// 删除商品
export function deleteGood(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/delete.ac`,
    method: 'post',
    data,
  });
}

// 查询库存流水列表
export function queryGoodsStoredRecords(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/stored/queryGoodsStoredRecords.ac`,
    method: 'post',
    data,
    params,
  });
}

// 多商品导入
export function importMultiGoods(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/importGoods.ac`,
    method: 'post',
    data,
    params,
  });
}

// 查询单品列表
export function querySingleGoodsRecords(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sku/selectGoodsSkuList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 快捷修改商品成本价
export function updateGoodsCostPrice(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/updateGoodsCostPrice.ac`,
    method: 'post',
    data,
  });
}
// 获取商品是否被使用
export function getGoodsIsUse(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/isUse.ac`,
    method: 'post',
    params,
  });
}
// 商品同步进销存
export function syncGoodsImport(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/syncGoodsImport.ac`,
    method: 'post',
    params,
  });
}
